import { Suspense } from 'react'
import { Route, Routes as ReactRouterRoutes } from 'react-router-dom'
import UserConsumptionProducts from 'user-consumption-products'
import UserPlan from 'user-plan'
import UserSignature from 'user-signature'
import { Route as UserPlanRoutes } from '~constants/routes'
import DrawerCheckout from '../exposes/drawer-checkout'

function Routes() {
  return (
    <Suspense fallback={<span>Loading...</span>}>
      <ReactRouterRoutes>
        <Route index element={<UserPlan onClose={() => null} />} />
        <Route path={UserPlanRoutes.USER_SIGNATURE} element={<UserSignature />} />
        <Route path={UserPlanRoutes.USER_CONSUMPTION_PRODUCTS} element={<UserConsumptionProducts />} />
        <Route path={UserPlanRoutes.CHECKOUT} element={
          <DrawerCheckout
            isOpen
            product={{ 
              price: 50,
              name: 'Frete Destaque Extra.',
              description: 'Para quem quer agilidade e desempenho máximo na captação de motoristas.',
            }}
          />}
        />
      </ReactRouterRoutes>
    </Suspense>
  )
}

export default Routes
